import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountrySelectionComponent } from './country-selection.component';
import {
  LoadingIconModule,
  SharedAngularComponentsAvlaModule,
  SmartadminDatatableModule,
  SmartadminInputModule,
  SmartadminModule,
  SmartadminValidationModule,
} from 'shared-angular-components-avla';

@NgModule({
  imports: [
    CommonModule,
    SmartadminModule,
    SmartadminDatatableModule,
    SmartadminValidationModule,
    SmartadminInputModule,
    LoadingIconModule,
    SharedAngularComponentsAvlaModule.forRoot(),
  ],
  declarations: [CountrySelectionComponent],
  exports: [CountrySelectionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CountrySelectionModule {}
